import { useState, useEffect, useRef } from "react";

const ActionsMenu = ({ trigger, children, className = "", wrapperClassName = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleToggle = (e) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const handleItemClick = (callback) => {
        return (e) => {
            e.stopPropagation();
            setIsOpen(false);
            if (callback) {
                callback(e);
            }
        };
    };

    return (
        <div className={`actions-menu-wrapper position-relative ${wrapperClassName}`} ref={menuRef}>
            <div onClick={handleToggle}>
                {trigger}
            </div>

            {isOpen && (
                <div className={`actions-menu position-absolute ${className}`}>
                    {typeof children === 'function' 
                        ? children({ onItemClick: handleItemClick })
                        : children
                    }
                </div>
            )}
        </div>
    );
};

export default ActionsMenu;
